import groupBy from 'lodash/groupBy';
import isNull from 'lodash/isNull';

import { EntryListItem, PatientVaccinationData } from 'chaika-frontend-types/frontend-cms';

import { SimpleList } from '@store/models/SimpleList';

import { DateHelper } from '@utils/DateHelper';
import { isDefined } from '@utils/isDefined';

import { NO_DISEASE_GROUP_NAME } from '@modules/patient/ui/EhrPage/pages/VaccinationPage/components/VaccinationTable/VaccinationTable';

type VaccinationData = PatientVaccinationData & VaccinationEntryData;

type VaccinationFilters = {
    parentEntryId?: string;
    entryDateStart?: Date;
    entryDateEnd?: Date;
    vaccinationDateStart?: Date;
    vaccinationDateEnd?: Date;
    vaccine?: string;
    disease?: string;
};

type VaccinationEntryData = {
    entryCreationDate?: string; // Date;
};

export class VaccinationList extends SimpleList<VaccinationData, VaccinationFilters> {
    public addEntryData(entries: EntryListItem[]): void {
        const grouped = groupBy(this.values, 'parentEntryId');

        entries.forEach(entry => {
            const [vaccination] = grouped[entry.id];

            if (isDefined(vaccination)) {
                this.update(vaccination.id, { entryCreationDate: entry.creationTime });
            }
        });
    }

    protected filterValue(value: VaccinationData, filters: VaccinationFilters): boolean {
        const filterByEntryId = isDefined(filters.parentEntryId) ? value.parentEntryId === filters.parentEntryId : true;
        const filterByEntryDateStart = isDefined(filters.entryDateStart)
            ? isDefined(value.entryCreationDate) &&
              DateHelper.isSameOrAfter(value.entryCreationDate, filters.entryDateStart)
            : true;
        const filterByEntryDateEnd = isDefined(filters.entryDateEnd)
            ? isDefined(value.entryCreationDate) &&
              DateHelper.isSameOrBefore(value.entryCreationDate, filters.entryDateEnd)
            : true;
        const filterByVaccinationDateStart = isDefined(filters.vaccinationDateStart)
            ? DateHelper.isSameOrAfter(value.vaccinationDate, filters.vaccinationDateStart)
            : true;
        const filterByVaccinationDateEnd = isDefined(filters.vaccinationDateEnd)
            ? DateHelper.isSameOrAfter(value.vaccinationDate, filters.vaccinationDateEnd)
            : true;
        const filterByVaccine = isDefined(filters.vaccine)
            ? !isNull(value.vaccine.match(new RegExp(filters.vaccine))) || value.vaccine === filters.vaccine
            : true;
        const filterByDisease = isDefined(filters.disease)
            ? !isNull(value.disease?.match(new RegExp(filters.disease, 'gi')) ?? null) ||
              value.vaccine === filters.vaccine ||
              (!isDefined(value.disease) && filters.disease === NO_DISEASE_GROUP_NAME())
            : true;

        return (
            filterByEntryId &&
            filterByEntryDateStart &&
            filterByEntryDateEnd &&
            filterByVaccinationDateStart &&
            filterByVaccinationDateEnd &&
            filterByVaccine &&
            filterByDisease
        );
    }
}
